import { create } from 'zustand';
import { DEFAULT_PACKAGE_INFO_LIST, PackageInfoItem, AgreementConfig } from 'lib/constants/operator';

type GlobalStoreProps = {
  finishInitData: boolean;
  smsModalTheme: string;
  // 移动权益调用最大月份
  maxMonth: number;
  // 手机号输入弹窗的图片
  mobileInputModalImg: string;
  mobileInputModalButtonText: string;
  smsModalMobilePromotionImg: string;
  smsModalDefaultButtonImg: string;
  landscapeNoticeImg: string;
  landscapeNoticeText: string;
  freeLotteryModalGiftsImg: string;
  // 是否展示挽留弹窗
  isShowRetainModal: boolean;
  // pid→弹窗样式类型映射
  smsModalStyleMap: Record<string, string>;
  // 套餐信息列表
  smsModalPackageInfoList: PackageInfoItem[];
  // 翼支付样式3协议合规配置（全局单例，仅 dxyzf 弹窗，由 SMSAgreementConfig 组件注入）
  smsModalAgreement: AgreementConfig | null;
};

interface GlobalStore extends GlobalStoreProps {
  initGlobalData: (props: Partial<GlobalStoreProps>) => void;
  completeInit: () => void;
}

export const useGlobalStore = create<GlobalStore>((set) => ({
  initGlobalData: (props: Partial<GlobalStoreProps>) => set({ ...props }),
  completeInit: () =>
    set({
      finishInitData: true,
    }),
  finishInitData: false,
  smsModalMobilePromotionImg: 'https://act.ecovision.gtimg.com/static/imgs/static/static_1752462752723.png',
  smsModalDefaultButtonImg: 'https://act.ecovision.gtimg.com/static/imgs/static/static_1752463036197.png',
  smsModalTheme: '',
  maxMonth: 6,
  mobileInputModalImg: '',
  mobileInputModalButtonText: '',
  landscapeNoticeText: '',
  landscapeNoticeImg: '',
  freeLotteryModalGiftsImg: '',
  isShowRetainModal: false,
  smsModalStyleMap: {},
  smsModalPackageInfoList: DEFAULT_PACKAGE_INFO_LIST,
  smsModalAgreement: null,
}));
